import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { customerReferralStageQueries } from '@/services/pointConfiguration/pointConfiguration.queries';

export const useReferralStageDetail = (stageId: string) => {
  const { data, isLoading } = useQuery({
    ...customerReferralStageQueries.detail({ stageId }),
  });
  return { referralStage: data?.data, loading: isLoading };
};
